import { paymentViewDefaultConfig, SignupState, signupViewDefaultConfig } from '.'
import {
  ACTION_SET_ACCOUNT,
  ACTION_SET_CALCULATED_PRICE,
  ACTION_SET_CONFIG,
  ACTION_SET_CURRENCY,
  ACTION_SET_DEFAULT_CONFIG,
  ACTION_SET_SELECTED_PRODUCT
} from './actions'

export function reducer(state: SignupState, action: any): SignupState {
  switch (action.type) {
    case ACTION_SET_CONFIG:
      return {
        ...state,
        signupViewConfig: action.payload.createAccountConfig,
        paymentViewConfig: action.payload.paymentDetailsConfig,
        progress: action.payload.progress,
        isLoadingConfig: false
      }
    case ACTION_SET_DEFAULT_CONFIG:
      return {
        ...state,
        signupViewConfig: signupViewDefaultConfig,
        paymentViewConfig: paymentViewDefaultConfig,
        isLoadingConfig: false
      }
    case ACTION_SET_ACCOUNT:
      return { ...state, account: action.payload }
    case ACTION_SET_CURRENCY:
      return { ...state, currency: action.payload }
    case ACTION_SET_CALCULATED_PRICE:
      return { ...state, calculatedPrice: action.payload }
    case ACTION_SET_SELECTED_PRODUCT:
      return { ...state, selectedProduct: action.payload }
    default:
      return state
  }
}
